import { useMediaQuery } from 'react-responsive';

import { MOBILE_DEVICE_MAX_WIDTH } from '../utils/constants';

export const useResponsive = () => {
  const isMobile = useMediaQuery({ maxWidth: MOBILE_DEVICE_MAX_WIDTH });
  const isDesktop = useMediaQuery({ minWidth: MOBILE_DEVICE_MAX_WIDTH + 1 });
  return { isMobile, isDesktop };
};
